<template>
    <div v-if="isMounted" class="adv" v-can="'settings_advertiser.access'">
        <ds-table :data="adv" :heads="heads" expand :max-items="10" :view-items="[10, 15, 20]" search>
            <template v-slot:header>
                <vs-button v-can="'settings_advertiser.create'" @click="create" class="mr-4 whitespace-no-wrap"
                           color="primary" type="border" v-bind="$iconData('icon-plus', 'fi-rr-plus')">
                    {{ $t('buttons.Create_advertiser') }}
                </vs-button>
            </template>

            <template v-slot:name="{name}">
                <div>{{name.name || name.id || '-'}}</div>
            </template>

            <template v-slot:integrations="{integrations}">
                <vs-chip v-tooltip.position.left="integrations.integrationsList.join('<br>')">
                    <vs-avatar color="#f0f0f0" text-color="#175ea5" v-bind="$iconData('icon-git-branch', 'fi-rr-code-branch')"/>
                    <span>{{ integrations.integrationsLength }}</span>
                </vs-chip>
            </template>

            <template v-slot:geo="{geo}">
                <vs-chip v-tooltip.position.left="geo.geosList.join('<br>')">
                    <vs-avatar color="#f0f0f0" text-color="#175ea5" v-bind="$iconData('icon-globe', 'fi-rr-globe')"/>
                    <span>{{ geo.geosLength }}</span>
                </vs-chip>
            </template>

            <template v-slot:falcon="{falcon}">
                <vs-chip class="product-order-status" :transparent="!!falcon.is_falcon"
                         :color="falcon.is_falcon ? 'success' : ''" :style="falcon.is_falcon ? '' : ''">
                    <div class="con-vs-avatar">
                            <span class="vs-avatar--text material-icons">
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11"
                                     :fill="falcon.is_falcon ? '#28C76F' : '#C3C3C3'">
                                <path
                                    d="M1.92775 0.72273C1.24903 1.42486 0.906738 2.13284 0.906738 2.83789C0.906738 2.99879 0.91844 3.13629 0.935994 3.14507C0.953547 3.15385 0.965249 3.19188 0.965249 3.22698C0.965249 3.3089 1.03546 3.51076 1.12908 3.70092C1.25195 3.95544 1.43041 4.1339 1.91605 4.48496C2.29637 4.75996 2.50701 5.07007 2.57722 5.46209L2.61525 5.67273L2.72057 5.62885C2.98679 5.51475 3.19158 5.47379 3.80302 5.40943C4.19504 5.36847 4.34717 5.30996 4.52855 5.13151C4.786 4.87406 4.66313 4.7073 3.8586 4.23044C2.99265 3.71555 2.68254 3.47566 2.3461 3.0573C2.07695 2.72087 1.93945 2.44294 1.87216 2.09773C1.8078 1.77592 1.89557 1.26688 2.09158 0.810495C2.14717 0.675921 2.19397 0.5589 2.19397 0.547197C2.19397 0.485761 2.09743 0.550123 1.92775 0.72273Z"/>
                                <path
                                    d="M9.72724 0.959639C9.71261 0.971341 9.67458 1.02985 9.64825 1.08836C9.47857 1.45113 8.91687 1.79342 8.03043 2.06842C7.95144 2.09474 7.81101 2.1357 7.72325 2.16496C7.63548 2.19129 7.46288 2.24687 7.34293 2.28198C5.85383 2.73544 5.59346 2.96948 5.06101 4.31522C4.82112 4.91788 4.69532 5.11974 4.44665 5.28357C4.23894 5.424 4.06926 5.47081 3.59825 5.52932C2.84931 5.62001 2.55968 5.70778 2.32564 5.91549C2.18229 6.03836 2.13548 6.16708 2.13548 6.42453C2.13548 6.54155 2.12378 6.64395 2.11208 6.65272C2.09745 6.6615 2.07112 6.74049 2.05064 6.83118C2.02139 6.95405 2.02139 7.01549 2.04772 7.09448C2.08867 7.21442 2.20277 7.31389 2.30516 7.31389C2.3783 7.31389 2.38123 7.29341 2.32564 7.16177C2.31394 7.12958 2.33149 7.08863 2.38123 7.03597C2.44559 6.97161 2.47777 6.96283 2.67671 6.96283C2.9049 6.96283 2.98096 6.93942 3.08921 6.83996C3.15064 6.78437 3.15357 6.78437 3.23548 6.87506C3.40809 7.06522 3.85862 7.33437 4.42032 7.58597C4.68655 7.70591 4.8533 7.84927 4.9791 8.07161C5.06394 8.21788 5.07564 8.25884 5.07564 8.46948C5.07564 8.81176 4.95277 9.04581 4.71288 9.15698C4.67192 9.17746 4.61341 9.20379 4.58708 9.21841C4.55782 9.23304 4.44958 9.24474 4.34426 9.24474H4.1541L4.09266 9.38224C4.05756 9.46123 4.01367 9.55778 3.99027 9.59873C3.95809 9.66309 3.95809 9.68357 3.99027 9.73038C4.0283 9.78012 4.04 9.77426 4.18043 9.63091C4.32671 9.48171 4.4174 9.43783 4.4174 9.51974C4.4174 9.54315 4.36474 9.60166 4.3033 9.65139C4.15995 9.76549 4.13947 9.8474 4.20676 10.0405C4.26234 10.1985 4.33548 10.2453 4.35304 10.137C4.35889 10.1048 4.40277 10.0405 4.44958 9.99368C4.49639 9.9498 4.53442 9.89421 4.53442 9.87373C4.53442 9.85325 4.5549 9.82107 4.5783 9.80059C4.64266 9.74793 4.66899 9.84155 4.62804 9.98783C4.60171 10.0873 4.60463 10.1166 4.64266 10.1575C4.67192 10.1897 4.6807 10.2336 4.66899 10.2833C4.65729 10.336 4.66314 10.3564 4.68947 10.3564C4.73043 10.3564 4.82697 10.2658 4.82697 10.2277C4.82697 10.216 4.8533 10.1663 4.88841 10.1195C4.94984 10.0317 4.95277 10.0142 4.89718 9.70405C4.88841 9.64554 4.89133 9.59581 4.90304 9.59581C4.96447 9.59581 5.17511 9.73038 5.18681 9.77719C5.20729 9.85325 5.29506 9.80937 5.29506 9.72161C5.29506 9.61043 5.21607 9.48756 5.11952 9.44368C5.02298 9.40272 5.00543 9.33836 5.08442 9.31496C5.26873 9.25645 5.44133 9.15113 5.59639 8.99607C5.78362 8.81469 5.8158 8.77666 5.93575 8.60113C6.1025 8.35831 6.25756 8.25006 6.43601 8.25006C6.68176 8.25006 7.4541 8.59528 8.05091 8.97267C8.32883 9.1482 8.87298 9.52852 8.96367 9.61043C8.98123 9.62799 9.0807 9.70113 9.18601 9.77719C9.29133 9.85033 9.47272 9.99075 9.58974 10.0902C9.70676 10.1868 9.81208 10.2687 9.82378 10.2687C9.92032 10.2687 9.9525 10.0171 9.86766 9.94102C9.83841 9.91762 9.73601 9.85325 9.63947 9.80059C9.42591 9.68065 9.01341 9.40272 8.83495 9.25352C8.43123 8.92294 7.91633 8.27639 7.57405 7.67081C7.54187 7.62107 7.49213 7.53038 7.45995 7.47187C7.21421 7.04182 6.74612 6.49474 6.62032 6.49474C6.57059 6.49474 6.57059 6.49182 6.64958 6.11443C6.67298 5.99448 6.70809 5.78969 6.72564 5.66097C6.7783 5.30405 6.85437 4.8974 6.90995 4.69554C7.06793 4.10166 7.40437 3.68916 8.0158 3.34395C8.87298 2.85538 9.21527 2.55405 9.46101 2.06549C9.59266 1.80512 9.61899 1.74076 9.69798 1.4482C9.73894 1.299 9.78867 0.936234 9.7682 0.936234C9.76234 0.936234 9.74479 0.947937 9.72724 0.959639Z"/>
                                <path
                                    d="M4.66605 7.87851C4.66019 7.89899 4.65142 7.97213 4.64264 8.04819C4.62509 8.25298 4.48759 8.52505 4.32961 8.67133C4.13945 8.84978 4.02243 8.90537 3.92296 8.86734C3.882 8.85271 3.76498 8.8293 3.66551 8.82053C3.51924 8.80297 3.46658 8.81175 3.39636 8.85271C3.3203 8.89659 3.30567 8.92585 3.30567 9.01654C3.30567 9.14526 3.30275 9.14234 3.41099 9.08382C3.4578 9.06042 3.51338 9.03994 3.53386 9.03994C3.5953 9.03994 3.5719 9.09845 3.49583 9.13356C3.41099 9.17159 3.38759 9.24473 3.38174 9.47292C3.37881 9.64553 3.43147 9.71281 3.47828 9.58994C3.49291 9.55191 3.54849 9.49925 3.60115 9.46999C3.65674 9.44074 3.7328 9.36467 3.77376 9.30324C3.84982 9.17452 3.89078 9.15404 3.89078 9.2418C3.89078 9.42904 3.98732 9.43781 4.06924 9.25643C4.11897 9.15696 4.1453 9.13063 4.18041 9.14526C4.27695 9.18622 4.39105 9.19207 4.432 9.15696C4.47296 9.12186 4.47003 9.11015 4.41445 9.05164C4.37934 9.01361 4.35301 8.97851 4.36179 8.97265C4.42615 8.92585 4.56658 8.89367 4.70993 8.89367C4.96738 8.89367 5.00248 8.84978 5.00248 8.5192C5.00248 8.18276 4.91472 7.94287 4.77137 7.88143C4.69823 7.85218 4.67482 7.84925 4.66605 7.87851Z"/>
                                <path
                                    d="M7.021 8.5075C7.021 8.52213 7.12924 8.58942 7.26382 8.65671C7.91036 8.999 8.30823 9.37054 8.45743 9.78304C8.52472 9.9615 8.52765 10.0259 8.46913 10.1604C8.396 10.3389 8.38429 10.336 8.85823 10.3213C9.28536 10.3067 9.53695 10.2599 9.53695 10.1926C9.53695 10.1604 9.18589 9.82985 9.05717 9.74501C9.02206 9.72161 8.98988 9.69235 8.9811 9.68357C8.97233 9.6748 8.91382 9.62799 8.84945 9.57825C8.78509 9.53145 8.71488 9.47879 8.69733 9.46416C8.67685 9.4466 8.63004 9.4115 8.59493 9.38517C8.5569 9.35591 8.47499 9.29155 8.41062 9.24182C8.34626 9.19208 8.24679 9.12479 8.19121 9.09554C8.05663 9.0224 7.97472 8.96974 7.95717 8.94926C7.93669 8.92586 7.53296 8.70644 7.3428 8.61575C7.25504 8.57479 7.1585 8.52798 7.13217 8.51336C7.0678 8.47825 7.021 8.47532 7.021 8.5075Z"/>
                            </svg>
                            </span>
                    </div>
                    <span v-if="!falcon.is_falcon">{{falcon.typeName}}</span>
                    <span v-else>Falcon</span>
                </vs-chip>
            </template>

            <template v-slot:status="{status}">
                <div>
                    <vs-switch :loading="loading" v-can="'settings_advertiser.change_status'" color="success" v-model="status.is_active"
                               @click.stop.prevent="changeAdvertiserStatus(status)" icon-pack="feather"
                               vs-icon-off="icon-x" vs-icon-on="icon-check"/>
                    <vs-switch v-can:show="'settings_advertiser.change_status'" disabled color="success"
                               v-model="status.is_active" icon-pack="feather" vs-icon-off="icon-x"
                               vs-icon-on="icon-check"/>
                </div>
            </template>

            <template v-slot:action="{action}">
                <div class="flex items-center h-full">
                    <vs-button
                        :disabled="loading"
                        v-can="'settings_advertiser.create'"
                        @click.stop="createIntegration(action)"
                        v-tooltip="$t('buttons.Create_integration')"
                        radius
                        color="primary"
                        type="flat"
                        v-bind="$iconData('icon-plus', 'fi-rr-plus')"
                    ></vs-button>
                    <vs-button
                        v-can:show="'settings_advertiser.create'"
                        disabled
                        v-tooltip="$t('buttons.Create_integration')"
                        radius
                        color="primary"
                        type="flat"
                        v-bind="$iconData('icon-plus', 'fi-rr-plus')"
                    ></vs-button>

                    <vs-button
                        :disabled="loading"
                        v-can="'settings_advertiser.update'"
                        @click.stop="edit(action)"
                        v-tooltip="$t('modals.Edit_advertiser')"
                        radius
                        color="primary"
                        type="flat"
                        v-bind="$iconData('icon-edit-2', 'fi-rr-file-edit')"
                    ></vs-button>
                    <vs-button
                        v-can:show="'settings_advertiser.update'"
                        disabled
                        radius
                        color="primary"
                        type="flat"
                        v-bind="$iconData('icon-edit-2', 'fi-rr-file-edit')"
                    ></vs-button>

                    <vs-button
                        :disabled="loading"
                        v-can="'settings_advertiser.create'"
                        @click.stop="copyAdv(action)"
                        v-tooltip="$t('modals.CloneAdv')"
                        radius
                        color="primary"
                        type="flat"
                        icon-pack="feather"
                        icon="icon-copy"
                        v-bind="$iconData('icon-copy', 'fi-rr-copy-alt')"
                    ></vs-button>

                    <vs-button
                        :disabled="loading"
                        v-if="action.is_falcon"
                        @click.stop="globalIntUpdate(action)"
                        v-tooltip="$t('modals.Global_update_int')"
                        radius color="primary" type="flat"
                        icon-pack="feather" icon="icon-aperture"
                        v-bind="$iconData('icon-aperture', 'fi-rs-aperture')"
                    ></vs-button>
                    <vs-button
                        v-if="!action.is_falcon"
                        disabled
                        v-tooltip="$t('modals.Global_update_int')"
                        radius
                        color="primary"
                        type="flat"
                        v-bind="$iconData('icon-aperture', 'fi-rs-aperture')"
                    ></vs-button>

                    <vs-button
                        :disabled="loading"
                        v-if="servers"
                        @click.stop="sync(action)"
                        v-can="'settings_advertiser.replicate'"
                        v-tooltip="$t('buttons.sync')"
                        radius
                        color="primary"
                        type="flat"
                        v-bind="$iconData('icon-shuffle', 'fi-rr-shuffle')"
                    ></vs-button>

                    <vs-button
                        :disabled="loading"
                        v-can="'settings_advertiser.destroy'"
                        @click.stop="destroy(action)"
                        v-tooltip="$t('tooltip.delete_advertiser')"
                        radius
                        color="primary"
                        type="flat"
                        v-bind="$iconData('icon-trash-2', 'fi-rr-trash')"
                    ></vs-button>
                    <vs-button
                        v-can:show="'settings_advertiser.destroy'"
                        disabled
                        radius
                        color="primary"
                        type="flat"
                        v-bind="$iconData('icon-trash-2', 'fi-rr-trash')"
                    ></vs-button>
                </div>
            </template>

            <template v-slot:expand="{expand}">
                <advertiser-details
                    :loading="loading"
                    :detailsData="expand"
                    :available_fields="available_fields"
                    class="a-details"
                ></advertiser-details>
            </template>
        </ds-table>
    </div>
</template>

<script>
import EventBus from '@/store/eventBus'
import ErrorHandler from '@/utils/errorHandler'
import send from '@/utils/fetch'
import {notifications, systemSettings} from '@/utils/mixins'
import AdvertiserDetails from '@/views/settings/advertisers/AdvertiserDetails.vue'
import {getSystemSetting} from '@/utils/utils'

export default {
    mixins: [notifications, systemSettings],

    data() {
        return {
            loading: false,
            isMounted: false,
            advList: [],
            typeList: [],
            currentAdv: null,
            heads: [
                {name: 'global.Name', key: 'name', sortKey: 'name', value: 'name', display: true},
                {name: 'global.Integrations', key: 'integrations', sortKey: 'integrationsLength', value: 'integrations', headerPosition: 'center', display: getSystemSetting('advertisers_show_integrations_and_geo')},
                {name: 'global.Geo', key: 'geo', sortKey: 'geosLength', value: 'geo', headerPosition: 'center', display: getSystemSetting('advertisers_show_integrations_and_geo')},
                {name: 'global.type', key: 'falcon', sortKey: 'typeName', value: 'falcon', headerPosition: 'center', width: '150px', display: true},
                {name: 'global.Status', key: 'status', sortKey: 'is_active', value: 'status', headerPosition: 'center', width: '60px', display: true},
                {name: 'global.Actions', key: 'action', value: 'action', headerPosition: 'end', width: '250px', display: true}
            ],
            available_fields: []
        }
    },

    computed: {
        adv() {
            return this.advList
        },

        servers() {
            return (JSON.parse(process.env.VUE_APP_API_SERVERS) || []).length
        },
    },

    components: {
        AdvertiserDetails
    },

    methods: {
        async sync(data) {
            try {
                const response = await send(`${this.$url.advrtsr.replicate}/${data.id}/replicate`, 'POST', {}, false)
                    .then(response => response.data.result.responses)

                this.syncServer(response, 3000)
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        create() {
            EventBus.$emit('emitPopupEvent', {type: 'createAdvertiser', name: this.$t('buttons.Create_advertiser'), ids: {types: this.typeList}})
        },

        edit(data) {
            EventBus.$emit('emitPopupEvent', {
                type: 'editAdvertiser',
                name: this.$t('modals.Edit_advertiser'),
                ids: {data, types: this.typeList}
            })
        },

        copyAdv(data) {
            EventBus.$emit('emitPopupEvent', {type: 'cloneAdvertiser', name: this.$t('modals.CloneAdv'), ids: data})
        },

        createIntegration(data) {
            EventBus.$emit('emitPopupEvent', {
                type: 'createIntegration',
                name: this.$t('buttons.Create_integration'),
                ids: {...data, available_fields: this.available_fields}
            })
        },

        globalIntUpdate(data) {
            EventBus.$emit('emitPopupEvent', {
                type: 'globalIntegrationUpdate',
                name: this.$t('modals.Global_update_int'),
                data: data
            })
        },

        changeAdvertiserStatus(data) {
            this.currentAdv = data.id

            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: this.$t('confirm.Confirm_action'),
                text: data.is_active ? this.$t('confirm.deactivateAdvertiser') : this.$t('confirm.activateAdvertiser'),
                accept: this.confirmStatus,
                acceptText: (data.is_active ? this.$t('buttons.Deactivate') : this.$t('buttons.Activate')).toUpperCase(),
                cancelText: this.$t('global.Cancel')
            })
        },

        async confirmStatus() {
            try {
                await send(this.$url.advrtsr.change_status, 'PUT', {data: {id: this.currentAdv}})
                await this.get()
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        destroy(data) {
            this.currentAdv = data.id

            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: this.$t('confirm.Confirm_action'),
                text: this.$t('confirm.destroyAdvertiser'),
                accept: this.confirmDestroy,
                acceptText: this.$t('buttons.Delete'),
                cancelText: this.$t('global.Cancel')
            })
        },

        async confirmDestroy() {
            try {
                await send(this.$url.advrtsr.destroy, 'DELETE', {data: {id: this.currentAdv}})
                await this.get()
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        async getTypes() {
            try {
                const response = await send(this.$url.advrtsr_integration.getIntegrationType, 'GET')
                    .then(response => response.data.result)

                this.typeList = response.integration_types
                this.available_fields = response.available_fields
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        unique(array) {
            return Array.from(new Set(array))
        },

        mutations(array) {
            return array.map(item => {
                let integrations = []
                let geos = []
                if (item.advertiser_integrations) {
                    integrations = item.advertiser_integrations.map(item => item.name)
                    geos = this.unique(item.advertiser_integrations.map(item => item.geo.name))
                } else {
                    item.advertiser_integrations = []
                }


                item.name = item.name || item.id
                item.integrationsLength = integrations.length
                item.geosLength = geos.length
                item.integrationsList = integrations
                item.geosList = geos

                const type = this.typeList.find(type => item.integration_type_id === type.id)
                if (type && type.name) item.typeName = type.name
                if (item.is_falcon) item.typeName = 'Falcon'

                return item
            })
        },

        async get() {
            try {
                this.loading = true
                const response = await send(this.$url.advrtsr.get, 'GET')
                    .then(response => response.data.result.advertisers)

                await this.getTypes()

                this.advList = this.mutations(response).reverse()

                this.advList.forEach(item => {
                    item.advertiser_integrations.forEach(item => {
                        item.geo_name = item.geo.name
                        item.traffic_model_name = item.traffic_model.name
                        item.countriesLength = item.countries.length
                        item.offersLength = item.offers_accepted.length

                        return item
                    })
                })
            } catch (e) {
                new ErrorHandler(e).send
            } finally {
                this.loading = false
            }
        }
    },

    async mounted() {
        EventBus.$on('getAdv', async () => {
            await this.get()
        })

        EventBus.$on('intGlobalUpdate', async () => {
            this.loading = true
            await this.get()
        })

        await this.get()

        this.isMounted = true
    },

    destroyed() {
        EventBus.$off('getAdv')
        EventBus.$off('intGlobalUpdate')
    }
}
</script>

<style lang="scss">
.adv {
    .bg-chip-transparent.vs-chip-success {
        color: #28C76F !important;
    }
}
</style>
